// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = require('./_object-keys-internal');
var hiddenKeys = require('./_enum-bug-keys').concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};



//////////////////
// WEBPACK FOOTER
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/~/core-js/modules/_object-gopn.js
// module id = ../../../../core-js/modules/_object-gopn.js
// module chunks = 0